<div id="map" class="map-container h-screen"></div>
